import axios from 'axios'
import { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'

export default function Modal({ setOpenModal, auditorias }) {
  //console.log(auditorias)
  var user = authService.getCurrentUser()
  const [campos, setCampos] = useState('')
  const [pessoas, setPessoas] = useState([])

  const auditoriasSelecionadas = []
  //useEffect(() => {
  auditorias.forEach(auditoria => {
    auditoriasSelecionadas.push(auditoria.IdRetornoAuditoria)
  })
  //})

  //console.log(auditoriasSelecionadas)

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/pessoa/list/' +
        user[0].IdEmpresa +
        '/' +
        sessionStorage.IdUnidade
      )
      .then(response => {
        //console.log(pessoas)
        setPessoas(response.data)
      })
  }, [])

  function enviaRelatorio() {
    let mensagem = 'E-mail enviado! '
    console.log(auditorias)
    auditorias.forEach(auditoria => {
      //emails alternativos
      if (campos !== '') {
        //console.log("campos: " + auditorias)
        axios.get(
          process.env.REACT_APP_API_URL + '/api/v1/auditoria/' + auditoria.IdRetornoAuditoria
        )
          .then(response => {
            //console.log("57")
            if (response.data.length > 0) {
              axios
                .post(process.env.REACT_APP_API_URL + '/api/v1/send_email', {
                  IdRetornoAuditoria: auditoria.IdRetornoAuditoria,
                  to: campos.target.value,
                  guid: response.data[0].audCodigoGUID,
                  origem: "campos != vazio"
                })
                .then(response => {
                  console.log(response.data.message)
                  if (response.status === 200) {
                    mensagem = mensagem + ' E-mail enviado para: ${campos.target.value},'
                  } else {
                    mensagem = mensagem + ' Erro ao enviar para: ${campos.target.value},'
                  }
                })
            }
          })
        // .catch(error => {
        //   console.log(error.status)
        //   alert("campos: " + error.status)
        // })
      }
      //responsavel pela auditoria
      axios
        .get(
          process.env.REACT_APP_API_URL + '/api/v1/auditoria/' + auditoria.IdRetornoAuditoria
        )
        .then(response => {
          //console.log("57")
          if (response.data.length > 0) {
            axios
              .post(process.env.REACT_APP_API_URL + '/api/v1/send_email', {
                IdRetornoAuditoria: auditoria.IdRetornoAuditoria,
                to: response.data[0].audEmailResponsavel,
                guid: response.data[0].audCodigoGUID,
                origem: "obtendo auditoria"
              })
              .then(response => {
                console.log(response.data.message)
                if (response.status === 200) {
                  mensagem = mensagem + ' E-mail enviado para: ${response.data[0].audEmailResponsavel},'
                } else {
                  mensagem = mensagem + ' Erro ao enviar para: ${response.data[0].audEmailResponsavel},'
                }
              })
          }
        })
      // .catch(error => {
      //   console.log(error.status)
      //   alert("responsavel: " + error)
      // })

      //destinatarios selecionados na lista
      destinatarios.forEach(destinatario => {

        //console.log(auditoria)
        axios
          .get(
            process.env.REACT_APP_API_URL + '/api/v1/auditoria/' + auditoria.IdRetornoAuditoria
          )
          .then(response => {
            //console.log("57")
            if (response.data.length > 0) {
              axios
                .post(process.env.REACT_APP_API_URL + '/api/v1/send_email', {
                  IdRetornoAuditoria: auditoria.IdRetornoAuditoria,
                  to: destinatario.pesEmail,
                  guid: response.data[0].audCodigoGUID,
                  origem: "destinatarios"
                })
                .then(response => {
                  console.log(response.data.message)
                  if (response.status === 200) {
                    mensagem = mensagem + ' E-mail enviado para: ${destinatario.pesEmail},'
                  } else {
                    mensagem = mensagem + ' Erro ao enviar para: ${destinatario.pesEmail},'
                  }
                })
            }
          })
        // .catch(error => {
        //   console.log(error.status)
        //   alert("destinatarios: " + error)
        // })
      })
    })
    //return
    alert(mensagem)
    //window.location.reload()
  }
  const [destinatarios, setDestinatarios] = useState([])
  function handleDestinatario(event) {
    const newList = destinatarios.filter(item => item.pesEmail !== event.target.name)
    //console.log(newList)
    if (event.target.checked == true) {
      const newList2 = newList.concat({
        pesEmail: event.target.name
      })
      setDestinatarios(newList2)
      //console.log(newList2)
    }
    else {
      setDestinatarios(newList)
      //console.log(newList)
    }
    //console.log(destinatarios)
    // if (event.target.checked == true) {
    //   if (destinatarios.length == 0) {
    //     const newList = destinatarios.filter(item => item.pesEmail !== event.target.name)
    //     setDestinatarios(newList)
    //   }
    //   else {
    //     const newList = destinatarios.concat({ pesEmail: event.target.name })
    //     setDestinatarios(newList)
    //   }

    // } else {
    //   const newList = destinatarios.filter(item => item.pesEmail !== event.target.name)
    //   const newList2 = newList.concat({
    //     pesEmail: event.target.name
    //   })
    //   setDestinatarios(newList2)

    // }


  }
  return (
    <>

      <div
        onClick={() => {
          setOpenModal(false)
        }}
        className="overlay"
      ></div>
      <div className="modalPadrao-content">
        <div className="cxTituloPadrao">
          <h1>
            Selecione os destinatários
            <hr className="hrTitleModal" />
          </h1>
        </div>
        <form>
          <label>E-mail alternativo:</label>
          <input
            type="email"
            id="fname"
            name="txtNotaValor"
            onChange={setCampos}
          ></input>
          <div
            className="tabelaPadrao"
            style={{
              marginTop: '10px',
              left: '0',
              width: '100%',
              height: '250px'
            }}
          >
            <table>
              <thead>
                <th>Nome</th>
                <th>E-Mail</th>
                <th>Função</th>
                <th>Envio</th>
              </thead>
              <tbody>
                {pessoas
                  .filter(val => {
                    if (val.pesStatus === 1) {
                      return val
                    }
                  })
                  .map(pessoa => (
                    <tr>
                      <td>{pessoa.pesNome}</td>
                      <td>{pessoa.pesEmail}</td>
                      <td>{pessoa.fncDescricao}</td>
                      <td>
                        <label className="container">
                          <input
                            name={pessoa.pesEmail}
                            type="checkbox"
                            onChange={handleDestinatario} />
                          <span className="checkmark"></span>
                        </label>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="caixaSalvarPadrao">
            <button onClick={enviaRelatorio}>Enviar</button>
          </div>
        </form>
      </div>
    </>
  )
}
